<template>
    <base-form
        :unique-id="uniqueId"
        :is-modal-form="isModalForm"
        :form-title="formTitle"
        :theme="theme"
        :submit-title="submitTitle"
        :fields="fields"
        :on-submit="onSubmit"
        :form-price="formPrice"
        form-class="order-form"
    ></base-form>
</template>

<script>
    import {emailTest, phoneTest, domainTest} from "../regex";
    import isArray from "lodash/isArray";
    import {baseFormMixin} from "../mixins";

    export default {
        mixins: [baseFormMixin],
        props: {
            /**
             * Цены
             */
            prices: {
                required: false,
                type: Array,
                validator: prices => {
                    if (!isArray(prices)) {
                        return false;
                    }

                    for (let price of prices) {
                        if (typeof price.name !== 'string' || price.name.length < 1) {
                            return false;
                        }
                        if (typeof price.value !== 'number' || price.value < 1) {
                            return false;
                        }
                    }

                    return true;
                }
            },
        },

        computed: {
            fields() {
                return {
                    name: {
                        type: 'text',
                        placeholder: 'Представьтесь, пожалуйста',
                        required: true,
                        messages: {
                            empty: 'Представьтесь, пожалуйста',
                            invalid: 'Представьтесь, пожалуйста',
                        },
                    },
                    email: {
                        type: 'text',
                        placeholder: 'Ваш E-mail',
                        required: true,
                        messages: {
                            empty: 'Введите ваш E-mail',
                            invalid: 'Укажите корректный E-mail',
                        },
                        validation: value => emailTest.test(value)
                    },
                    phone: {
                        type: 'phone',
                        placeholder: 'Ваш телефон',
                        required: true,
                        messages: {
                            empty: 'Введите ваш номер телефона',
                            invalid: 'Укажите корректный номер телефона',
                        },
                        validation: value => phoneTest.test(value)
                    },
                    domain: {
                        type: 'text',
                        placeholder: 'Адрес вашего Битрикс 24',
                        required: true,
                        messages: {
                            empty: 'Введите адрес Вашего Битрикс 24',
                            invalid: 'Укажите корректный адрес Битрикс 24',
                        },
                        validation: value => domainTest.test(value)
                    },
                    ...this.prices ? {
                        price: {
                            type: 'radio',
                            placeholder: 'Выберите период',
                            messages: {
                                empty: 'Выберите период',
                                invalid: 'Указан неверный период',
                            },
                            required: true,
                            values: this.prices,
                        }
                    } : {},
                }
            }
        },

        methods: {
            onSubmit(values) {
                return axios.post('/form', {...values, ...{formName: this.theme, formTitle: this.formTitle}});
            }
        },
    }
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/components/OrderForm.vue